import { render, staticRenderFns } from "./ProfileDataFormGroup.vue?vue&type=template&id=5f18a12c"
import script from "./ProfileDataFormGroup.vue?vue&type=script&lang=js"
export * from "./ProfileDataFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports